function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 88,
  r: 8
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 424,
  r: 8
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 424,
  cy: 256,
  r: 8
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 256,
  r: 8
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 110.5,
  cy: 172,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 401.5,
  cy: 340,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 110.5,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 401.5,
  r: 8
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 110.5,
  cy: 340,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 401.5,
  cy: 172,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 110.5,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 401.5,
  r: 8
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M269.9 248c-2.9-5-8.1-7.8-13.4-8l-30-55.4c-2.3-3.8-7.2-5-11-2.7s-5 7.2-2.7 11l29.6 54.9c-2.9 4.8-3.2 11.1-.2 16.3 1.5 2.5 3.5 4.5 5.9 5.8V384c0 4.4 3.6 8 8 8s8-3.6 8-8V269.9c7.6-4.5 10.2-14.2 5.8-21.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0 81.2-81.2 81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"
}));

function SvgIosClockOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosClockOutline);
export default __webpack_public_path__ + "static/media/ios-clock-outline.8f728c0a.svg";
export { ForwardRef as ReactComponent };